import React, { Fragment } from 'react'
import PropTypes from 'prop-types'
import Event from '@app/models/event'
import Label from './Label'

const Tours = ({ event }) => {
  return event.preparatoryTour ? (
    <Label tour="preparatory" event={event} />
  ) : (
    <>
      <Label tour="trial" event={event} />
      <Label tour="main" event={event} />
    </>
  )
}

Tours.propTypes = {
  event: PropTypes.instanceOf(Event).isRequired
}

export default Tours
